import { Text } from '@cmpsr/components';

type IntroWizardStepTitleProps = {
  activeStep: number;
};

export default function IntroWizardStepTitle(props: IntroWizardStepTitleProps) {
  return renderSwitch(props.activeStep);
}

function renderSwitch(activeStep: number): React.ReactNode {
  switch (activeStep) {
    case 1: {
      return (
        <Text as="h1" variant="text-header-L" color="text-light">
          Every question maps to one of 500+{' '}
          <Text as="span" textStyle="text-header-l-v" color="text-light !important">
            risk factors
          </Text>
        </Text>
      );
    }
    case 2: {
      return (
        <Text as="h1" variant="text-header-L" color="text-light">
          Powered by AI, built from{' '}
          <Text as="span" textStyle="text-header-l-v" color="text-light !important">
            clinical research
          </Text>
        </Text>
      );
    }
    case 3: {
      return (
        <Text as="h1" variant="text-header-L" color="text-light">
          Review your results at your{' '}
          <Text as="span" textStyle="text-header-l-v" color="text-light !important">
            personalized dashboard
          </Text>
        </Text>
      );
    }
    case 4: {
      return (
        <Text as="h1" variant="text-header-L" color="text-light">
          Reduce your risk up to{' '}
          <Text as="span" textStyle="text-header-l-v" color="text-light !important">
            60%
          </Text>
        </Text>
      );
    }
  }
}
